import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Switch, Typography } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';
import type { BackupVault } from '@/data/vaults/backupVault';
import { AwsKmsTextField } from './awsKmsTextField';
import { AzureKeyVaultKeyUriTextField } from './azureKeyVaultKeyUriTextField';
import { GcpKmsTextField } from './gcpKmsTextField';
import { Accordion, AccordionDetails, AccordionSummary } from '../accordion';
export const VaultAdvanceOptions = t0 => {
  const $ = _c(15);
  const {
    disabled,
    backupVault,
    setBackupVault,
    customKey,
    setCustomKey,
    vaultAccountId,
    defaultAzureTenantId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Divider sx={{
      margin: "0 -40px"
    }} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AccordionSummary><Typography variant="h4">Advanced options</Typography></AccordionSummary>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      paddingRight: "0"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== backupVault || $[5] !== customKey || $[6] !== defaultAzureTenantId || $[7] !== disabled || $[8] !== setBackupVault || $[9] !== setCustomKey || $[10] !== vaultAccountId) {
    t5 = <Accordion>{t2}<AccordionDetails sx={t3}><Stack gap="16px" divider={t4}><KmsKeyOption disabled={disabled} backupVault={backupVault} setBackupVault={setBackupVault} customKey={customKey} setCustomKey={setCustomKey} vaultAccountId={vaultAccountId} defaultAzureTenantId={defaultAzureTenantId} /></Stack></AccordionDetails></Accordion>;
    $[4] = backupVault;
    $[5] = customKey;
    $[6] = defaultAzureTenantId;
    $[7] = disabled;
    $[8] = setBackupVault;
    $[9] = setCustomKey;
    $[10] = vaultAccountId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider sx={{
      margin: "0 -40px"
    }} />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5) {
    t7 = <Stack gap="12px">{t1}{t5}{t6}</Stack>;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
const KmsKeyOption = t0 => {
  const $ = _c(28);
  const {
    disabled,
    backupVault,
    setBackupVault,
    customKey,
    setCustomKey,
    vaultAccountId,
    defaultAzureTenantId
  } = t0;
  const isGcp = backupVault.vaultAttributes.cloudProvider === Provider.Gcp;
  const isAzure = backupVault.vaultAttributes.cloudProvider === Provider.Azure;
  let t1;
  if ($[0] !== backupVault || $[1] !== isAzure || $[2] !== isGcp || $[3] !== setBackupVault) {
    t1 = () => {
      if (isGcp) {
        setBackupVault({
          ...backupVault,
          vaultAttributes: {
            ...backupVault.vaultAttributes,
            gcp: {
              ...backupVault.vaultAttributes.gcp,
              encryptionKey: ""
            }
          }
        });
      } else {
        if (isAzure) {
          setBackupVault({
            ...backupVault,
            vaultAttributes: {
              ...backupVault.vaultAttributes,
              azure: {
                ...backupVault.vaultAttributes.azure,
                encryptionKey: "",
                cmkKeyVaultTenantId: "",
                cmkAppRegistrationId: ""
              }
            }
          });
        } else {
          setBackupVault({
            ...backupVault,
            vaultAttributes: {
              ...backupVault.vaultAttributes,
              aws: {
                ...backupVault.vaultAttributes.aws,
                encryptionKey: ""
              }
            }
          });
        }
      }
    };
    $[0] = backupVault;
    $[1] = isAzure;
    $[2] = isGcp;
    $[3] = setBackupVault;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const clearEncryptionKey = t1;
  let t2;
  if ($[5] !== clearEncryptionKey || $[6] !== setCustomKey) {
    t2 = event => {
      setCustomKey(event.target.checked);
      if (!event.target.checked) {
        clearEncryptionKey();
      }
    };
    $[5] = clearEncryptionKey;
    $[6] = setCustomKey;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== customKey || $[9] !== disabled || $[10] !== t2) {
    t3 = <Switch size="small" disabled={disabled} checked={customKey} onChange={t2} />;
    $[8] = customKey;
    $[9] = disabled;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = isGcp ? "Use my own Cloud KMS key" : isAzure ? "Use my own Key Vault key" : "Use my own KMS key";
  let t5;
  if ($[12] !== t4) {
    t5 = <Typography>{t4}</Typography>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <Stack direction="row" gap="12px" alignItems="center">{t3}{t5}</Stack>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== backupVault || $[18] !== customKey || $[19] !== defaultAzureTenantId || $[20] !== isAzure || $[21] !== isGcp || $[22] !== setBackupVault || $[23] !== vaultAccountId) {
    t7 = customKey && <Stack width="400px" justifyContent="flex-end">{isGcp ? <GcpKmsTextField backupVault={backupVault} setBackupVault={setBackupVault} /> : isAzure ? <AzureKeyVaultKeyUriTextField backupVault={backupVault} setBackupVault={setBackupVault} vaultAccountId={vaultAccountId} defaultAzureTenantId={defaultAzureTenantId} /> : <AwsKmsTextField backupVault={backupVault} setBackupVault={setBackupVault} />}</Stack>;
    $[17] = backupVault;
    $[18] = customKey;
    $[19] = defaultAzureTenantId;
    $[20] = isAzure;
    $[21] = isGcp;
    $[22] = setBackupVault;
    $[23] = vaultAccountId;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t6 || $[26] !== t7) {
    t8 = <Stack className="w-full" gap="24px"><Stack direction="row" justifyContent="space-between" alignItems="center">{t6}{t7}</Stack></Stack>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};